var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessGuideWrapper",staticStyle:{"display":"flex","align-items":"center"}},[_c('p',{staticStyle:{"opacity":"0.7"}},[_vm._v("此功能需要统一接入阿里云AK/SK，调整期间API等相关功能暂时无法使用，对此给您带来的不便深表歉意。")])])
}]

export { render, staticRenderFns }